import React from 'react'
import {Redirect} from "@reach/router";
import {isSessionActive} from "../_core/service";

const Secured = ({children}: React.PropsWithChildren<any>) => {
  if (!isSessionActive()) {
    return <Redirect to="/login" noThrow/>
  }
  return children;
}

export default Secured;
